<template>
  <c-loading-area :loading="loading">
    <v-card-title>
      {{ $t('page.makePayment.caseSearch.title') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('page.makePayment.caseSearch.description') }}
    </v-card-subtitle>
    <v-card-text>
      <v-row no-gutters class="mt-4">
        <v-col cols="12">
          <v-radio-group v-model="bean.caseSearchCriteria.searchType"
                         @change="clearSearchData"
                         :label="$t('page.makePayment.caseSearch.searchType.title')"
                         class="mt-0">
            <v-radio class="my-2"
                     :label="$t('page.makePayment.caseSearch.searchType.caseNumber')"
                     value="caseNumber"/>
          </v-radio-group>
        </v-col>
        <v-col cols="12">
          <div v-if="bean.caseSearchCriteria.searchType === 'caseNumber'">
            <c-text-field
              v-model="bean.caseSearchCriteria.caseNumber"
              :label="$t('page.makePayment.caseSearch.searchType.caseNumber')"
              key="caseNumber"
              required
              maxlength="250"
              outlined
              hide-details="auto"
              aria-describedby="03d58a6f-b7cd-427a-bace-580f21af42ba"/>
            <field-description id="03d58a6f-b7cd-427a-bace-580f21af42ba"
                               message-key="'page.makePayment.caseSearch.searchType.caseNumber.description"/>
          </div>
          <div v-if="bean.caseSearchCriteria.searchType === 'citationNumber'">
            <c-text-field
              v-model="bean.caseSearchCriteria.citationNumber"
              :label="$t('page.makePayment.caseSearch.searchType.citationNumber')"
              key="citationNumber"
              required
              maxlength="250"
              outlined
              hide-details="auto"
              aria-describedby="573600fe-a7e0-4bb3-9c0c-4a4f3a373845"/>
            <field-description id="573600fe-a7e0-4bb3-9c0c-4a4f3a373845"
                               message-key="'page.makePayment.caseSearch.searchType.citationNumber.description"/>
          </div>
          <div v-if="bean.caseSearchCriteria.searchType === 'cid'">
            <c-text-field
              v-model="bean.caseSearchCriteria.cid"
              :label="$t('page.makePayment.caseSearch.searchType.cid')"
              key="cid"
              required
              maxlength="250"
              outlined
              hide-details="auto"
              aria-describedby="ce8fa3bb-1f96-44be-9b97-afdbd4e13a88"/>
            <field-description id="ce8fa3bb-1f96-44be-9b97-afdbd4e13a88"
                               message-key="'page.makePayment.caseSearch.searchType.cid.description"/>
          </div>
          <div v-if="bean.caseSearchCriteria.searchType === 'licensePlateNumber'">
            <c-text-field
              v-model="bean.caseSearchCriteria.vehiclePlateNumber"
              :label="$t('page.makePayment.caseSearch.searchType.licensePlateNumber')"
              key="vehiclePlateNumber"
              required
              maxlength="250"
              outlined
              hide-details="auto"
              aria-describedby="b04b8c8d-f7eb-4e8e-a0bb-da1a16402b1e"/>
            <field-description id="b04b8c8d-f7eb-4e8e-a0bb-da1a16402b1e"
                               message-key="'page.makePayment.caseSearch.searchType.licensePlateNumber.description"/>
          </div>
          <div v-if="bean.caseSearchCriteria.searchType === 'driversLicenseNumber'">
            <c-text-field
              v-model="bean.caseSearchCriteria.driversLicenseNumber"
              :label="$t('page.makePayment.caseSearch.searchType.driversLicenseNumber')"
              key="driversLicenseNumber"
              required
              maxlength="250"
              outlined
              hide-details="auto"
              aria-describedby="20abdd0c-8a82-4cf1-a9ce-550a3466616d"/>
            <field-description id="20abdd0c-8a82-4cf1-a9ce-550a3466616d"
                               message-key="'page.makePayment.caseSearch.searchType.driversLicenseNumber.description"/>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="mt-10 justify-end">
      <c-btn type="primary" @click="save">
        {{ $t('global.continue') }}
      </c-btn>
    </v-card-actions>
  </c-loading-area>
</template>

<script>
import _ from 'lodash';
import WorkflowStepMixin from '@/mixins/workflowStep';
import { scrollTo } from '@/application/utility';
import axios from 'axios';

export default {
  mixins: [WorkflowStepMixin],
  methods: {
    clearSearchData () {
      this.bean.caseSearchCriteria.caseNumber = null;
      this.bean.caseSearchCriteria.citationNumber = null;
      this.bean.caseSearchCriteria.cid = null;
      this.bean.caseSearchCriteria.vehiclePlateNumber = null;
      this.bean.caseSearchCriteria.driversLicenseNumber = null;
    },
    validate () {
      this.$cove.validation.clear();

      if (this.bean.caseSearchCriteria.searchType === 'caseNumber') {
        this.$cove.validation.required(this.bean.caseSearchCriteria.caseNumber,
          'page.makePayment.caseSearch.searchType.caseNumber', 'caseNumber');
      } else if (this.bean.caseSearchCriteria.searchType === 'citationNumber') {
        this.$cove.validation.required(this.bean.caseSearchCriteria.citationNumber,
          'page.makePayment.caseSearch.searchType.citationNumber', 'citationNumber');
      } else if (this.bean.caseSearchCriteria.searchType === 'cid') {
        this.$cove.validation.required(this.bean.caseSearchCriteria.cid,
          'page.makePayment.caseSearch.searchType.cid', 'cid');
      } else if (this.bean.caseSearchCriteria.searchType === 'licensePlateNumber') {
        this.$cove.validation.required(this.bean.caseSearchCriteria.vehiclePlateNumber,
          'page.makePayment.caseSearch.searchType.licensePlateNumber', 'vehiclePlateNumber');
      } else if (this.bean.caseSearchCriteria.searchType === 'driversLicenseNumber') {
        this.$cove.validation.required(this.bean.caseSearchCriteria.driversLicenseNumber,
          'page.makePayment.caseSearch.searchType.driversLicenseNumber', 'driversLicenseNumber');
      } else {
        // This should only happen with a configuration error
        this.$cove.validation.addError('searchType', 'page.makePayment.caseSearch.validation.searchType');
      }

      return !this.$cove.validation.hasErrors();
    },
    save () {
      let isValid = this.validate();
      if (!isValid) {
        scrollTo(this.CONST.ERROR_CONTAINER_SELECTOR);
      } else {
        this.$cove.block();
        let query = {
          ...(!_.isNil(this.bean.caseSearchCriteria.caseNumber) && { caseNumber: this.bean.caseSearchCriteria.caseNumber }),
          ...(!_.isNil(this.bean.caseSearchCriteria.citationNumber) && { citationNumber: this.bean.caseSearchCriteria.citationNumber }),
          ...(!_.isNil(this.bean.caseSearchCriteria.cid) && { cid: this.bean.caseSearchCriteria.cid }),
          ...(!_.isNil(this.bean.caseSearchCriteria.vehiclePlateNumber) &&
              { vehiclePlateNumber: this.bean.caseSearchCriteria.vehiclePlateNumber }),
          ...(!_.isNil(this.bean.caseSearchCriteria.driversLicenseNumber) &&
              { driversLicenseNumber: this.bean.caseSearchCriteria.driversLicenseNumber })
        };
        axios.get(this.$cove.getAPI({ name: 'api.search.cases.payment', query }))
          .then((response) => {
            if (!_.isNil(response.data) && response.data.length > 0)
            {
              this.bean.caseSearchResults = _.sortBy(response.data, 'filedDate');
              if (this.bean.caseSearchResults.length === 1) {
                // if only 1 returned select it by default
                this.bean.selections.caseInstanceUUID = this.bean.caseSearchResults[0].caseInstanceUUID;
              }
              this.$emit('save', this.bean);
            }
            else
            {
              // the searchTypes match the field keys so this should highlight the displayed field.
              this.$cove.validation.addError(this.bean.caseSearchCriteria.searchType, 'page.makePayment.caseSearch.validation.noCaseFound');
            }
          }).finally(() => {
            this.$cove.unblock();
          });
      }
    }
  }
};
</script>
